document.addEventListener("DOMContentLoaded", function () {
  const toggle = document.getElementById("mobileMenuToggle");
  const drawer = document.getElementById("mobileDrawer");
  const closeBtn = document.getElementById("mobileClose");

  toggle.addEventListener("click", function () {
    drawer.classList.add("active");
    document.body.classList.add("no-scroll");
  });

  closeBtn.addEventListener("click", function () {
    drawer.classList.remove("active");
    document.body.classList.remove("no-scroll");
  });
});



